// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import * as SectionRoleDescription from "../../components/SectionRoleDescription/SectionRoleDescription.bs.jsx";

function get(state, field) {
  return state.role;
}

function set(_state, field, value) {
  return {
    role: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function SendInvitation(props) {
  let onSubmit = props.onSubmit;
  let roleOptions = [
    10,
    20,
    50,
    80
  ];
  let form = Form.use({
    role: 10
  }, Validators$1.schema([]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = maybeErrorMessage$1 !== undefined ? maybeErrorMessage$1 : "Neznámá chyba";
  }
  return <DialogForm.make
    formId={"send_invitation"}
    heading={"Poslat pozvánku"}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        id={"send_invitation"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={"reset"}
        >
          <Form.Field.make
            field={"Role"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"role"}
              inputSlot={<select
                value={field.value.toString()}
                onChange={event => {
                  let roleString = event.target.value;
                  field.handleChange(Stdlib_Option.getOrThrow(Stdlib_Option.flatMap(Stdlib_Int.fromString(roleString, undefined), UserRoles.roleFromInt), undefined));
                }}
              >
                {roleOptions.map(role => {
                  let label = UserRoles.roleI18n(role);
                  let value = role.toString();
                  return <option
                    key={value} 
                    value={value}
                  >
                    {label}
                  </option>;
                })}
              </select>}
              labelSlot={"Role"}
            />}
          />
        </fieldset>
        {tmp}
      </form>
      <SectionRoleDescription.make />
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = SendInvitation;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
